import { render, staticRenderFns } from "./thumb-down.vue?vue&type=template&id=17c0137c"
import script from "./thumb-down.vue?vue&type=script&lang=js"
export * from "./thumb-down.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports